"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));

var _ModalHeaderWithTitleAndClose = _interopRequireDefault(require("./ModalHeaderWithTitleAndClose"));

var _ModalBody = _interopRequireDefault(require("./ModalBody"));

var _ModalFooter = _interopRequireDefault(require("./ModalFooter"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Backdrop = _styledComponents["default"].div.attrs(function () {
  return {
    id: "modal-backdrop"
  };
}).withConfig({
  displayName: "Modal__Backdrop",
  componentId: "sc-1bj8pa1-0"
})(["overflow:scroll;position:fixed;top:0;bottom:0;left:0;right:0;background-color:rgba(0,0,0,0.3);z-index:1052;"]);

var ModalDialog = _styledComponents["default"].div.attrs(function () {
  return {
    id: "modal"
  };
}).withConfig({
  displayName: "Modal__ModalDialog",
  componentId: "sc-1bj8pa1-1"
})(["&&&{@media (min-width:576px) and (max-width:992px){max-width:80%;}}"]);

var Modal = function Modal(_ref) {
  var show = _ref.show,
      children = _ref.children,
      size = _ref.size;
  return show && _react["default"].createElement(Backdrop, null, _react["default"].createElement(ModalDialog, {
    className: "modal-dialog modal-" + size
  }, _react["default"].createElement("div", {
    className: "modal-content"
  }, _react["default"].Children.map(children, function (child) {
    if (!child || !child.type) return null;

    if (child.type.displayName === "WithTitleAndClose") {
      return _react["default"].cloneElement(child, {});
    }

    if (child.type.displayName === "Header") {
      return _react["default"].cloneElement(child, {});
    }

    if (child.type.displayName === "Body") {
      return _react["default"].cloneElement(child, {});
    }

    if (child.type.displayName === "Footer") {
      return _react["default"].cloneElement(child, {});
    }
  }))));
};

Modal.Header = _ModalHeader["default"];
Modal.HeaderWithTitleAndClose = _ModalHeaderWithTitleAndClose["default"];
Modal.Body = _ModalBody["default"];
Modal.Footer = _ModalFooter["default"];
Modal.propTypes = {
  /** When to show the modal */
  show: _propTypes["default"].bool.isRequired,

  /** children with the other modal classes */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,

  /** size of the modal */
  size: _propTypes["default"].oneOf(["sm", "md", "lg"])
};
Modal.defaultProps = {
  size: "md"
};
var _default = Modal;
exports["default"] = _default;